import React from "react";
import ReactECharts from "echarts-for-react";
import ChartCard from "./ChartCard";


const axisNameColor = '#334155';
const labelColor = '#475569'
const axisLineColor = '#7798c3b4'
const axisLineWidth = 2;
const legendLabelColor = '#777c83'


const HorizontalBarChart = ({
    chartLabel,
    chartData = [],
    xField,
    yField,
    tooltipFields = [],
    fieldsLabel = "",
    barColor = "#7C4DFF",
    height = 420,
    purpose = "",
    xAxisTitle='',
    yAxisTitle='',
    legendLabel = "",
}) => {

    const formatDate = (date) => {
        if (!date) return "-";
        const d = new Date(date);
        if (isNaN(d)) return "-";
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };


    const graphData =
        chartData.length > 0
            ? chartData
            : [];
            
    const chartHeight = Math.max(
        180,
        graphData.length * 28
    );
    const option = {

        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow",
            },
            formatter: (params) => {
                
                const item = graphData[params[0].dataIndex];
                let html = `<b>${item[yField]}</b><br/><br/>`;
                if (purpose) {
                    html += `<br/><b>Purpose</b> : ${purpose}<br/><br/>`;
                }
                tooltipFields.forEach((field) => {
                    let value = item[field.key];
                    if (
                        field.key === "proposedStartDate" ||
                        field.key === "proposedEndDate" ||
                        field.key === "actualEndtDate"
                    ) {
                        value = formatDate(value);
                    }

                    html += `<b>${field.label}</b> : ${value ?? "-"}<br/>`;
                });

                

                return html;
            }
        },

        legend: {
            show: !!legendLabel,
            top: 0,
            left: "center",
            icon: "roundRect",
            itemWidth: 18,
            itemHeight: 10,
            textStyle: {
                fontSize: 12,
                fontWeight: 600,   // or 600, 700
                color: legendLabelColor,
            },
        },

        grid: {
            left: 30,
            right: 40,
            top: 30,
            bottom: 50,
            containLabel: true,
        },

        xAxis: {
            type: "value",
            show: true,
            name: xAxisTitle,
            nameLocation: "middle",
            nameGap: 50,
            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },
            splitLine: {
                lineStyle: {
                    color: "#ECECEC",
                },
            },

            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            },

            axisTick: {
                show: false,
            },

            axisLabel: {
                show: true,
                color: labelColor,
                fontSize: 11,
                rotate: 0,
            },
        },

        yAxis: {
            type: "category",
            data: graphData.map(item => item[yField]),
            show: true,
            name: yAxisTitle,
            nameLocation: "middle",
            nameGap: 150,
            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },
            axisTick: {
                show: false,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            },
            axisLabel: {
                show: true,
                width: 180,
                overflow: "break",
                lineHeight: 18,
                color: labelColor,
                fontSize: 11,
                rotate: 30,
            }
        },

        series: [
            {
                name: legendLabel || xField,
                type: "bar",
                data: graphData.map(item =>
                    Number(item[xField] || 0)
                ),
                barWidth: 20,
                itemStyle: {
                    color: barColor,
                    borderRadius: [0, 8, 8, 0],
                },
                label: {
                    show: true,
                    position: "right",
                    color: "#374151",
                    formatter: "{c}",
                },
            },

        ],
    };

    return (

        <ChartCard
            title={chartLabel}
            fields={fieldsLabel}
            height={height}
        >
            <div
                style={{
                    height: 420,
                    overflowY: "auto",
                }}
            >
                <ReactECharts
                    option={option}
                    style={{
                        width: "100%",
                        height: Math.max(
                            420,
                            graphData.length * 45
                        )
                    }}
                />
            </div>
        </ChartCard>

    );
};

export default HorizontalBarChart;